export type CartItem = {
  slug: string
  name: string
  href: string
  image: string
  price: number
  qty: number
}

const CART_KEY = 'doku-akustik-cart'

export function readCart(): CartItem[] {
  if (typeof window === 'undefined') return []
  try {
    const raw = window.localStorage.getItem(CART_KEY)
    if (!raw) return []
    const parsed = JSON.parse(raw) as CartItem[]
    return Array.isArray(parsed) ? parsed : []
  } catch {
    return []
  }
}

export function writeCart(items: CartItem[]) {
  if (typeof window === 'undefined') return
  window.localStorage.setItem(CART_KEY, JSON.stringify(items))
  window.dispatchEvent(new Event('doku-cart-updated'))
}

export function addToCart(item: Omit<CartItem, 'qty'>, qty = 1): CartItem[] {
  const cart = readCart()
  const existing = cart.find((c) => c.slug === item.slug)
  if (existing) {
    existing.qty += qty
  } else {
    cart.push({ ...item, qty })
  }
  writeCart(cart)
  return cart
}

export function setCartQty(slug: string, qty: number): CartItem[] {
  const cart = readCart()
  const next = cart
    .map((item) =>
      item.slug === slug ? { ...item, qty: Math.max(1, Math.floor(qty)) } : item
    )
    .filter((item) => item.qty > 0)
  writeCart(next)
  return next
}

export function removeFromCart(slug: string): CartItem[] {
  const next = readCart().filter((item) => item.slug !== slug)
  writeCart(next)
  return next
}

export function clearCart(): CartItem[] {
  writeCart([])
  return []
}

export function cartSubtotal(items: CartItem[]) {
  return items.reduce((sum, item) => sum + item.price * item.qty, 0)
}

export function cartVat(subtotal: number, rate = 0.2) {
  return subtotal * rate
}

export function cartTotalWithVat(items: CartItem[], rate = 0.2) {
  const subtotal = cartSubtotal(items)
  return subtotal + cartVat(subtotal, rate)
}
